import { Pipe, PipeTransform } from '@angular/core';
import { FileMetadata } from 'src/app/models/collection.interface';

type ProcessingStage = FileMetadata['processing_stage'];

@Pipe({
  name: 'statusColor',
  pure: true,
  standalone: true
})
export class StatusColorPipe implements PipeTransform {
  transform(stage: ProcessingStage | string): string {
    switch (stage) {
      case 'complete':
        return 'success'; // Green
      case 'failed':
        return 'error'; // Red
      case 'started':
        return 'warning'; // Yellow/Orange
      case 'image_extraction':
      case 'text_extraction':
      case 'preindexing':
        return 'info'; // Blue/Gray
      default:
        return 'info'; // Default or empty stage
    }
  }
}
